/* AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2024 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { FC } from "react";
import UnsupportedPdfImage from "../../assets/icons/unsupported-pdf-viewer.svg";
import { useTranslation } from "react-i18next";

export const PDFTooLarge: FC<{
  isDark?: boolean;
  isFullHeight?: boolean;
  onClick: () => void;
}> = ({ onClick, isDark, isFullHeight = false }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`large-content ${
        isFullHeight ? "full-h" : ""
      } w-100 p-t-xl bg-${
        isDark ? "dark" : "white"
      } d-flex flex-center flex-direction-column`}
    >
      <img src={UnsupportedPdfImage} alt="Unsupported PDF Viewer" />
      <p className="text-gray text-center m-t-xs">
        {t("file_support.file_too_large")}
        <br />
        {t("file_support.please_click_the_button_below_to_open_it")}
      </p>
      <button onClick={onClick} className="btn btn-primary">
        {t("general.open_new_tab")}
      </button>
    </div>
  );
};
